import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Paper, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { RangePlanningItem } from '../types';

interface RecipeUsageTabProps {
  item: RangePlanningItem;
}

/** Traceability chain: shows which Recipes use this item as an ingredient, linking through
 * to RecipeV2 detail (which in turn shows Menu usage via its own Usage tab). */
const RecipeUsageTab = ({ item }: RecipeUsageTabProps) => {
  const { t } = useTranslation('rangePlanningItems');
  const navigate = useNavigate();

  if (item.recipeUsage.length === 0) {
    return (
      <Paper variant="outlined"
        sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">
          {t('noRecipeUsage', 'This item is not currently used in any recipe.')}
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('recipeName', 'Recipe')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {item.recipeUsage.map((usage) => (
            <TableRow
              key={usage.recipeId}
              hover
              sx={{ cursor: 'pointer' }}
              onClick={() => navigate(`/store/recipes-v2/${usage.recipeId}`)}
            >
              <TableCell>
                <Stack direction="row"
                  spacing={1}
                  alignItems="center">
                  <Typography variant="textSM"
                    fontWeight={600}
                    color="primary.main">{usage.recipeName}</Typography>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default RecipeUsageTab;
